import React from 'react';

import ConfigurationForm from './ConfigurationForm';

const Configuration = ({ ...props }) => (
  <div>
    <h1>Configure Campaign</h1>
    <ConfigurationForm {...props} />
  </div>
);

Configuration.displayName = 'Configuration';

export default Configuration;



// WEBPACK FOOTER //
// ./src/containers/createCampaign/Configuration.js